module.exports = __webpack_public_path__ + "img/details-infobuisness.png?418668bafe3c5927bf99f3287d7a6baf";